// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"style_menuItem__1HCQ-","content":"style_content__26U_s"};